import { Component, ViewChild, AfterViewInit, OnDestroy, TemplateRef, } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { Router } from '@angular/router';
import { CommonService } from '../../../../../shared/services/common.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { IAInvoiceDashboard, InvoiceDetails } from '../../../../../shared/models/IAInvoiceDashboard';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-invoicedashboardia',
  templateUrl: './invoicedashboardia.component.html',
  styleUrl: './invoicedashboardia.component.css'
})
export class InvoicedashboardiaComponent implements AfterViewInit, OnDestroy {

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();
  private loadInvoiceSubscription: Subscription = new Subscription();


  dataSource!: MatTableDataSource<IAInvoiceDashboard>
  displayedColumns: string[] = ['Sr.No','InvoiceID', 'EventId', 'NameofEvent', 'Intervention', 'Component', 'EventStatus', 'NoOfMSMEAttended', 'InvoiceStatus', 'Action']


  invoiceDataSource!: MatTableDataSource<InvoiceDetails>
  displayedInvoiceColumns: string[] = ['Sr.No', 'eventId', 'invoiceId', 'dateofSubmission', 'dateofActionTaken', 'finalTotal', 'Download', 'Action', 'invoiceAccepted']

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) invoicePagination!: MatPaginator;

  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';

  IAId = sessionStorage.getItem('userId');

  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  reportData: any[] = [];
  allrecord: any[] = [];
  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  DtoPagination =
    {
      "IAId": this.IAId,
      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }
  constructor(private dialog: MatDialog,
    private apiService: ApiService, private router: Router,private toastr: ToastrService,  public commonService: CommonService) { }


  form = new FormGroup({
    searchControl: new FormControl('', [
      Validators.pattern(this.commonService.searchFilter)
      
    ])
  })

  DtoPaginationInvoice = {
    "PageNumber": 1,
    "PageSize": 10,
    "SortColumn": "",
    "SortDirection": "ASC",
    "SearchTerm": "",
    "SearchCol": "",
    "EventId": "",
  }

  async ngOnInit(): Promise<void> {
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchTerm = this.commonService.searchText;
  }

  ngAfterViewInit() {
    this.loadData();
  }

  /*invoiceCalculation(eventId: string, rejectedStatus: string) {
    sessionStorage.setItem("EventId", eventId);
    sessionStorage.setItem("RejectedStatus", rejectedStatus);
    this.router.navigate(['/invoicecalculation']);
    this.dialog.closeAll();
  }*/

  invoiceCalculation(eventId: string, resubmit: string, mode: string) {

    sessionStorage.setItem('EventId', eventId);
    sessionStorage.setItem('Resubmit', resubmit);
    sessionStorage.setItem('Mode', mode);           
    this.router.navigate(['/invoicecalculation'], {
      queryParams: {
        eventId: eventId,
        mode: mode
      }
    });
   }

  reSubmissionCalculation(eventId: string, rejectedStatus: string) {
    sessionStorage.setItem("EventId", eventId);
    sessionStorage.setItem("RejectedStatus", rejectedStatus);
    this.router.navigate(['/invoicecalculation']);
  }

  onSearchChange(e: any) {
    this.DtoPagination.SearchTerm = e.target.value;
    this.DtoPagination.PageNumber = 1;
    this.loadData();
  }

  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.loadData();
  }

  loadData() {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETEVENTLISTBYIAID, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
   
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        console.table(data)
        this.dataSource = data;
        this.adjustPaginator();
      });
  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.loadInvoiceSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

 

  //loadData() {
  //  this.sort.sortChange.subscribe(() => this.pagination.pageIndex = 0);
  //  merge(this.sort.sortChange, this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
  //    this.pagination.page)
  //    .pipe(filter(searchTerm => searchTerm != null),
  //      switchMap((searchTerm) => {
  //        if (searchTerm) {
  //          this.pagination.pageIndex = 0;
  //        }
  //        this.DtoPagination.SortColumn = this.sort.active;
  //        this.DtoPagination.SortDirection = this.sort.direction;
  //        //this.DtoPagination.SearchTerm = (searchTerm && typeof searchTerm == 'string') ? searchTerm.toString() : '';
  //        this.DtoPagination.SearchCol = this.commonService.searchText;
  //        return this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETEVENTLISTBYIAID, this.DtoPagination)
  //          .pipe(catchError(() => of(null)));
  //      }),
  //      map(resp => {
  //        if (resp.status) {
  //          this.length = resp['totalRecords'];
  //        }
  //        return resp.data;
  //      })
  //    ).subscribe(data => {
  //      this.dataSource = data;
  //      this.adjustPaginator();
  //    });
  //}

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  //CardRedirection(event: any) {
  //  const buttonId = (event.currentTarget as HTMLElement).id;
  //  switch (buttonId) {
  //    case 'btnTotalGrievances':
  //      this.commonService.searchText = '';
  //      this.loadData();
  //      break;
  //    case 'btnDisposedGrievances':
  //      this.commonService.searchText = 'Disposed';
  //      this.loadData();
  //      break;
  //    case 'btnPendingGrievances':
  //      this.commonService.searchText = 'Pending';
  //      this.loadData();
  //      break;
  //    case 'btnRejectedGrievances':
  //      this.commonService.searchText = 'Rejected';
  //      this.loadData();
  //      break;
  //    default:
  //      window.location.reload();
  //      break;
  //  }
  //}

  onSearchClick(searchValue: string): void {
    const searchControl = this.form.get('searchControl');
    searchControl?.markAsTouched();

    if (searchControl?.valid && searchValue.trim() !== '') {
      this.DtoPagination.PageNumber = 1;
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.DtoPagination.SearchCol = "";
      this.loadData();
    }
  }

  resetPage() {
    this.form.get('searchControl')?.setValue('');

    this.DtoPagination.PageNumber = 1;
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = "";
    this.loadData();
  }

  //LoadCardDetails() {
  //  this.apiService.getRequest(API_ENDPOINTS.MASTERS.GRIEVANCE.GETGRIEVANCECOUNTFORDASHBOARD).subscribe(
  //    result => {
  //      if (result.status) {
  //        this.totalGrievances = result.data.totalGrievances;
  //        this.disposedGrievances = result.data.disposedGrievances;
  //        this.pendingGrievances = result.data.pendingGrievances;
  //        this.rejectedGrievances = result.data.rejectedGrievances;
  //      }
  //    }
  //  )
  //}

  ViewAttendedMSME() { }

  exportToExcel(): void {
    const fileName = 'Invoice_Details.xlsx';

    const nullPagination = {
      IAId: this.IAId,
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: "eventDate",
      SortDirection: "desc",
      SearchTerm: ""
    };

    this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETEVENTLISTBYIAID, nullPagination).subscribe({
      next: (result) => {

        if (!result?.status || !result.data) {
          this.toastr.error('No data available to export.');
          return;
        }

        this.allrecord = result.data;

        if (this.allrecord.length === 0) {
          this.toastr.error('No data available to export.');
          return;
        }
        
        const excelData = this.allrecord.map((item: any, index: number) => ({
          'Sr. No': index + 1,
          'Invoice ID': item.invoiceID,
          'Event ID': item.eventId,
          'Name of Event': item.eventName,
          'Intervention': item.interventionName,
          'Component': item.interestName,
          'Event Status': item.eventStatus,
          'Total Verified MSME Attended': item.noOfMSMEAttended,
          'Invoice Status': item.invoiceStatus ?? 'Pending'
        }));

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

        // Auto column width
        const columnWidths = Object.keys(excelData[0]).map(key => ({ wch: key.length + 10 }));
        worksheet['!cols'] = columnWidths;

        const workbook: XLSX.WorkBook = {
          Sheets: { 'Invoice Data': worksheet },
          SheetNames: ['Invoice Data'],
        };

        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });

        this.saveExcelFile(excelBuffer, fileName);
      },
      error: () => {
        this.toastr.error('Failed to fetch data for export.');
      }
    });
  }

  //exportToExcel(): void {
  //  // Define the file name
  //  const fileName = 'Invoice_Details.xlsx';

  //  const DtonullPagination = {
  //    IAId: this.IAId,
  //    PageNumber: 1,
  //    PageSize: 9999999,
  //    SortColumn: "eventDate",
  //    SortDirection: "desc",
  //    SearchTerm: ""
  //  };

  //  this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETEVENTLISTBYIAID, DtonullPagination).subscribe({
  //    next: (result) => {
  //      if (!result || !result.status || !result.data) {
  //        this.toastr.error('No data available to export.');
  //        return;
  //      }

  //      this.allrecord = result.data;

  //      if (this.allrecord.length === 0) {
  //        this.toastr.error('No data available to export.');
  //        return;
  //      }

  //      // Prepare the data for export
  //      const excelData = this.allrecord.map((item, index) => ({
  //        'Sr. No': index + 1,
  //        'Name of Event': item.eventName,
  //        'Intervention': item.interventionName,
  //        'Component': item.interestName,
  //        'Event Status': item.eventStatus,
  //        'Count of MSME attended the event (Verified/Unverified)': item.noOfMSMEAttended,
  //        'Invoice Status': item.invoiceStatus,
  //      }));

  //      // Create a worksheet from the data
  //      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

  //      // Auto-adjust column widths for better visibility
  //      const columnWidths = Object.keys(excelData[0]).map((key) => ({ wch: key.length + 5 }));
  //      worksheet['!cols'] = columnWidths;

  //      // Create a workbook and append the worksheet with the name "Invoice Data"
  //      const workbook: XLSX.WorkBook = {
  //        Sheets: { 'Invoice Data': worksheet },
  //        SheetNames: ['Invoice Data'],
  //      };

  //      // Generate a buffer for the Excel file
  //      const excelBuffer: any = XLSX.write(workbook, {
  //        bookType: 'xlsx',
  //        type: 'array',
  //      });

  //      // Save the Excel file
  //      this.saveExcelFile(excelBuffer, fileName);
  //    },
  //    error: () => {
  //      this.toastr.error('Failed to fetch data for export.');
  //    }
  //  });
  //}



  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }


  //#region My Invoice Section
  invoicePageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  invoiceLength: number = 0;
  invoicePageSize: number = 10;
  invoiceDisplayedData: any[] = [];
  invoiceHidePageSize = false;
  invoiceShowPageSizeOptions = true;
  invoiceShowFirstLastButtons = true;
  invoiceDisabled = false;
  invoicePageIndex = 0;
  invoicePageEvent!: PageEvent;


  onPageInvoiceChange(e: PageEvent) {
    this.invoicePageEvent = e;
    this.invoiceLength = e.length;
    this.invoicePageSize = e.pageSize;
    this.invoicePageIndex = e.pageIndex;

    this.DtoPaginationInvoice.PageNumber = e.pageIndex + 1;
    this.DtoPaginationInvoice.PageSize = e.pageSize;

    // Fetch new data when pagination changes
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETENROLLEDMSMELISTFORMSSIDC, this.DtoPaginationInvoice)
      .pipe(catchError(() => of(null)))
      .subscribe(resp => {
        if (resp && resp.status) {
          this.displayedInvoiceColumns = resp.data;
          this.invoiceLength = resp.totalRecords;
        }
      });
  }

  viewInvoiceDetails(templateRef: TemplateRef<any>, eventId: string): void {
    if (!this.invoicePagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    if (this.loadInvoiceSubscription) {
      this.loadInvoiceSubscription.unsubscribe();
    }

    // Scroll to the top immediately when function is triggered
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Reset subscription with a new request
    this.loadInvoiceSubscription = merge(
      this.sort?.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.invoicePagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.invoicePagination.pageIndex = 0;
          this.DtoPaginationInvoice.SortColumn = this.sort?.active;
          this.DtoPaginationInvoice.SortDirection = this.sort?.direction;
          this.DtoPaginationInvoice.SearchCol = this.commonService.searchText;
          this.DtoPaginationInvoice.EventId = eventId;

          return this.apiService.getRequest(API_ENDPOINTS.MASTERS.INVOICE.GETINVOICEDOCUMENTDETAILS, this.DtoPaginationInvoice)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            console.table(resp.data)
            this.invoiceLength = resp.totalRecords;
            return resp?.data || {};
          }
          return null;
        })
      )
      .subscribe(data => {
        if (data) {
          this.invoiceDataSource = data;
          this.adjustInvoicePaginator();
          // Scroll to the top again to ensure proper placement after data load
          window.scrollTo({ top: 0, behavior: 'smooth' });
          this.notCallingPopup();
        }


        // Open dialog after grid data is updated
        const dialogRef2 = this.dialog.open(templateRef, {
          width: '1100px', // Customize the width of the dialog
          height: '60vh', // Optionally customize the height
        });

        dialogRef2.afterClosed().subscribe(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      });
    //this.router.navigate(['/reports/viewevent', uniqueEventId]);
    //this.closeDialog();
  }

  adjustInvoicePaginator() {
    const totalPages = Math.ceil(this.invoiceLength / this.invoicePageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.invoicePageIndex >= totalPages) {
      this.invoicePageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPaginationInvoice.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.invoicePagination.pageIndex = this.invoicePageIndex;
  }

  notCallingPopup() {
    this.loadDataSubscription.unsubscribe();
    this.loadInvoiceSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    //this.LoadGradingRecord();
  }

  onClosePopup() {
    this.DtoPaginationInvoice.PageNumber = 1;
    this.invoicePageIndex = 0;  
    this.invoicePagination.pageIndex = 0;  
  }

  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }

  openFilePreviewDialog(templateRef: TemplateRef<any>, filePath: string, fileName: string): void {
    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(templateRef, {
          width: '80%',
          height: '80%',
          data: { fileUrl, fileName }
        });
      },
      error: (err) => {
        console.error('File preview failed:', err);
      }
    });
  }
  //#endregion
}
